module.exports = __webpack_public_path__ + "static/hidromovil2.43ee1ed9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/hidromovil2.jpg
// module id = 1262
// module chunks = 35783957827783